import React, { useContext, useState } from 'react';
import OverLay from './Overlay';
import { Context } from '../../AppContext';
import './BPG.css';
import { BPG } from '../../pages/runtime-typechecker';
type BPGProps = {
  bpgInfo: BPG;
  isMobileDevice: boolean;
  fromCity: string;
  toCity: string;
};
const BPGSection = ({
  bpgInfo,
  isMobileDevice,
  fromCity,
  toCity
}: BPGProps) => {
  const {
    setSelectedKnowMoreDetailsForMobile,
    trackTemplateEvent
  } = useContext(Context);
  const [knowMoreDesktop, setKnowMoreDesktop] = useState(false);
  return null;
  return isMobileDevice ? (
    <>
      <div className={`BPG makeFlex appendBottom10`}>
        <div className={`BPGHeading vertlCenter appendLeft10`}>
          {bpgInfo.header}
        </div>
        <div className={`BPGElseGet vertlCenter appendLeft8`}>
          {bpgInfo.description}
        </div>
        <div
          onClick={() => {
            if (bpgInfo.know_more_details && bpgInfo.know_more_details) {
              setSelectedKnowMoreDetailsForMobile &&
                setSelectedKnowMoreDetailsForMobile(bpgInfo.know_more_details);
              trackTemplateEvent(
                `Cab_SEO_BPG_KnowMore_${fromCity}_${toCity}_Click`
              );
            }
          }}
          className={`cursorPointer BPGKnowMore vertlCenter appendLeft5`}
        >
          {bpgInfo.know_more_label}
        </div>
      </div>
    </>
  ) : (
    <div className={`BPG makeFlex appendBottom10`}>
      <div className={`BPGHeading vertlCenter appendLeft15`}>
        {bpgInfo.header}
      </div>
      <div className={`BPGElseGet vertlCenter appendLeft15`}>
        {bpgInfo.description}
      </div>
      <div
        onClick={() => {
          setKnowMoreDesktop(!knowMoreDesktop);
          trackTemplateEvent(
            `Cab_SEO_BPG_KnowMore_${fromCity}_${toCity}_Click`
          );
        }}
        className={`cursorPointer BPGKnowMore vertlCenter appendLeft8`}
      >
        {bpgInfo.know_more_label}
      </div>
      {knowMoreDesktop && bpgInfo.know_more_details ? (
        <OverLay
          cancelButton={() => setKnowMoreDesktop(false)}
          knowMoreDetails={bpgInfo.know_more_details}
        />
      ) : null}
    </div>
  );
};

export default BPGSection;
